/**
 * Momo Bridge
 * repository: https://git.wemomo.com/mmf/bridge
 * Syntax compatible with ES5
 * No guarantee or warranty for any other purpose of usage.

 */

var bridgeVersion = '1.6.0-beta.9';
var lastModified = 'Wed Mar 08 2023 18:25:52 GMT+0800 (China Standard Time)';
var MKTAG = '[mkbridge]';
if (mm$2) {
    console.warn(MKTAG, 'mm is already exist!');
}

var ua = window.navigator.userAgent;
var is_webview = /mo(mo|live|moGame)WebView/.test(ua);
var is_ios = /iP(ad|hone|od)/.test(ua);
var is_android = /[aA]ndroid/.test(ua);
var version = /momoWebView\/(\d+)\.(\d+)\.?(\d+)?/.exec(ua) || ['', '0', '0'];
var momo_version = version[1] + '.' + version[2] + (version[3] ? ('.' + version[3]) : '');
var mk_versions = /momoKit\/(\d+)\.(\d+)\.?(\d)?/.exec(ua) || ['', '0', '0'];
var mk_version = mk_versions[1] + '.' + mk_versions[2] + (mk_versions[3] ? ('.' + mk_versions[3]) : '');
var arr_build_version = /(ios|android)\/(\d+)\(/.exec(ua);
var build_version = !!arr_build_version ? arr_build_version[2] : 0;
var platform = is_ios ? 'ios' : is_android ? 'android' : 'unknown';
var query = {};
var is_mk = checkMK();

/**
 * 通过momo版本号判断版本支持
 *  e.g., mm.compare('6.2.4') >= 0 表示当前版本号高于目标版本（6.2.4）
 * @param {object|number|string} ver
 * @returns {number}
 */
function compare(ver) {
    var version;
    var verType = typeof ver;
    if (verType == 'string' || verType == 'number') {
        version = ver + '';
    } else if (verType == 'object') {
        version = ver[platform];
        if (!version) {
            return -101;
        }
    } else {
        console.error(MKTAG, 'Error Version');
        return -102;
    }
    var now = momo_version.split('.');
    var tar = version.toString().split('.');
    var len = Math.max(tar.length, now.length);
    try {
        for (var i = 0; i < len; i++) {
            var l = isFinite(now[i]) && Number(now[i]) || 0,
                r = isFinite(tar[i]) && Number(tar[i]) || 0;
            if (l < r) {
                /* 目标版本低于当前版本 */
                return -1;
            } else if (l > r) {
                /* 目标版本大于当前版本 */
                return 1;
            }
        }
    } catch (e) {
        return -1;
    }
    /* 相等 */
    return 0;
}

/**
 * 通过momo版本号判断版本支持
 *  e.g., mm.compareMK('1.0') >= 0 表示当前版本号高于目标版本（1.0）
 * @param {object|number|string} ver
 * @returns {number}
 */
function compareMK(ver) {
    var version;
    var verType = typeof ver;
    if (verType == 'string' || verType == 'number') {
        version = ver + '';
    } else if (verType == 'object') {
        version = ver[platform];
        if (!version) {
            return -101;
        }
    } else {
        console.error(MKTAG, 'Error Version');
        return -102;
    }
    var now = mk_version.split('.');
    var tar = version.toString().split('.');
    var len = Math.max(tar.length, now.length);
    try {
        for (var i = 0; i < len; i++) {
            var l = isFinite(now[i]) && Number(now[i]) || 0,
                r = isFinite(tar[i]) && Number(tar[i]) || 0;
            if (l < r) {
                /* 目标版本低于当前版本 */
                return -1;
            } else if (l > r) {
                /* 目标版本大于当前版本 */
                return 1;
            }
        }
    } catch (e) {
        return -1;
    }
    /* 相等 */
    return 0;
}

/**
 * 判断mk及momo客户端版本号
 * @inner
 * @param version
 * @returns {boolean}
 * @private
 */
function _checkVer(version) {
    if (!version.sdk) return false;

    if (compareMK(version.sdk) < 0) {
        if (version.momo) {
            return compare(version.momo) >= 0;
        } else {
            return false;
        }
    } else {
        return true;
    }
}

/**
 * bridge基本方法
 * @param module bridge命名空间
 * @param name bridge名称
 * @param param bridge传参
 * @param callback bridge回调
 * @returns {string} callbackID
 */
function commonInvoke(module, name, param, callback) {
    var callbackID = '';
    if (param) {
        try {
            var _obj = (typeof param == 'string') ? JSON.parse(param) : param;

            if (param.callback && typeof param.callback == 'function') {
                _obj.callback = this.createCallback(name, param.callback);
                callbackID = _obj.callback;
            }

            if (callback && typeof callback == 'function' && typeof _obj.callback == 'undefined') {
                _obj.callback = this.createCallback(name, callback);
                callbackID = _obj.callback;
            }
            if (typeof param.callback == 'string') {
                callbackID = param.callback;
            }

            param = JSON.stringify(_obj);

        } catch (err) {
            return;
        }
    }
    var invokeArr = module ? [module, name, param, callbackID] : [name, param, callbackID];
    prepare._adapter.invoke.apply(prepare, invokeArr);
    return callbackID;
}

/**
 * 用于检测当前环境是否为mk
 * @returns {boolean}
 */
function checkMK() {
    return (is_ios && compare('8.11.3') >= 0 && !!navigator.isMK) || /momoKit/.test(ua);
}

/**
 * bridgeHandler构建函数
 * @param callbackID
 * @constructor
 */
function BridgeHandler(callbackID) {
    this.callbackID = callbackID;
}

BridgeHandler.prototype.release = function () {
    this.callbackID && new Function(this.callbackID + '= null')();
};

try {
    location.search.substr(1).split('&').forEach(function (item) {
        (item.split('=')[0] in query) ? query[item.split('=')[0]].push(item.split('=')[1]) : query[item.split('=')[0]] = [item.split('=')[1]];
    });
} catch (err) {
    console.error(MKTAG, err);
}
var mm$2 = {
    version: bridgeVersion,
    last_modified: lastModified,
    is_webview: is_webview, // momo客户端或其他独立客户端
    momo_version: momo_version,
    mk_version: mk_version,
    build_version: build_version,
    platform: platform,
    query: query,
    bid: query._bid ? query._bid[0] : '',
    _callbacks: {},
    host: location.host,
    protocol: location.protocol,
    pathname: location.pathname,
    is_mk: is_mk,
    _uniqueId: 1,
    /*
    Invoke a function from the adapter
    invoke 方法，兼容mk 非mk
    */
    invoke: function (module, name, param, callback) {
        // convert to array and remove the first argument as that's the fn string.
        // NOTE: the callback fn is not in the arguments.
        var self = this;
        if (typeof name != 'string') {
            callback = param;
            param = name;
            name = module;
            module = null;
        }
        if (typeof param == 'function') {
            callback = param;
            param = {};
        }
        if (mm$2[module] && mm$2[module][name]) {
            return mm$2[module][name](param, callback);
        }
        return new BridgeHandler(commonInvoke.apply(this, arguments));

    },

    /**
     * 提供给各模块进行bridge构建的方法
     * @param {object} obj
     *  common: ios 、android 使用同一个配置
     *  ios: iOS的配置
     *  android: android的配置
     *  version: 开始支持的版本
     *
     * @returns {BridgeHandler}
     */
    build: function (obj) {
        if (obj.hasOwnProperty('common')) {
            obj.ios = obj.common;
            obj.android = obj.common;
        }
        if (!obj.hasOwnProperty(platform)) return;
        var args = obj[platform];
        if (obj.version && !_checkVer(obj.version)) {
            console.error(MKTAG, '当前版本不支持此功能，请检查升级');
            var callback = args[args.length - 1];
            if (callback && typeof (callback) == 'function') {
                callback({
                    status: '-99',
                    message: '当前版本不支持此功能，请检查升级',
                });
            }
        } else {
            return new BridgeHandler(commonInvoke.apply(this, args));
        }
    },

    /**
     * 创建callback字符串
     * @param name
     * @param callback
     * @returns {string}
     */
    createCallback: function (name, callback) {
        var callbackId = '__BRIDGE_CALLBACK__' + (this._uniqueId++) + '_' + new Date().getTime();
        if (!this._callbacks.hasOwnProperty(name)) {
            this._callbacks[name] = {};
        }
        this._callbacks[name][callbackId] = function () {
            var args = Array.prototype.slice.apply(arguments);
            // 处理转义字符

            if (name != 'getItem') {
                for (var i = 0; i < args.length; i++) {
                    try {
                        args[i] = JSON.parse(args[i]);
                    } catch (err) {

                    }
                }
            }

            callback.apply(null, args);
        };
        return 'mm._callbacks.' + name + '.' + callbackId;
    },

    /**
     * 事件传递时使用，为兼容直接invoke的调用，放到mm全局
     * @param type
     * @param name
     * @param data
     * @param origin
     */
    fireDocumentEvent: function (type, name, data, origin) {
        var evt;
        if (type == 'bridgeEvent') {
            name = 'be:' + name;
        }

        evt = document.createEvent('Events');
        evt.initEvent(name, false, false);
        evt.name = name;
        if (data) {
            try {
                evt.data = JSON.parse(data);
            } catch (err) {
                evt.data = data;
            }
        }
        if (origin) {
            evt.origin = origin;
        }
        document.dispatchEvent(evt);
    },
    compare: compare,
    compareMK: compareMK,
    checkMKiOSCanPostMessage:function(){
       return (typeof (window.webkit &&  window.webkit.messageHandlers &&  window.webkit.messageHandlers.mmBridgeBase && window.webkit.messageHandlers.mmBridgeBase.postMessage) == 'function');
    }
};
var prepare = {
    _native_obj: null,
    _adapter: null,
    initMK: function () {
        if (is_webview && is_ios) {
            this._adapter = this.iOS_MK_Adapter();
        } else if (is_webview && is_android) {
            this._adapter = this.Android_MK_Adapter();
        } else {
            this._adapter = this.MoAdapter();
        }
    },
    /**
     * 一个空的adapter实现
     * @returns {{name: string, invoke: invoke}}
     * @constructor
     */
    MoAdapter: function () {
        return {
            name: 'basic',
            invoke: function (module, name, param) {
                console.warn(MKTAG, module + '.' + name + '被调用，但无法执行对应行为。看看是不是不在mk环境？');
            },
        };
    },
    mkURL: function (module, name, param) {
        /*
            mk 拼接url
            */
        module = module || '';
        name = name || '';
        param = param || '{}';

        return 'mkjsbridge://' + module + '/' + name + '?param=' + encodeURIComponent(param);
    },
    iOS_MK_Adapter: function () {
        var _this = this;

        function creatIframe(url) {
            var mkfrm = document.createElement('iframe');
            mkfrm.style.display = 'none';
            mkfrm.src = url;
            document.documentElement.appendChild(mkfrm);
            var returnValue = mm$2.__RETURN_VALUE;
            mm$2.__RETURN_VALUE = undefined;

            mkfrm.parentNode.removeChild(mkfrm);
            return returnValue;
        }
        if(mm$2.checkMKiOSCanPostMessage()){
            return {
                name: 'ios',
                invoke: function (module, name, param, callback) {
                    window.webkit.messageHandlers.mmBridgeBase.postMessage({
                         namespace:module,
                         method:name,
                         param:param,
                         callback:callback,
                    });
                },
            }; 
        }
        return {
            name: 'ios',
            invoke: function (module, name, param) {
                setTimeout(function () {
                    creatIframe(_this.mkURL(module, name, param));
                }, 0);

            },
        };
    },
    Android_MK_Adapter: function () {
        /*
            mk android
            */
        var _this = this;
        if (window.mkAobj) {
            return {
                name: 'android aobj',
                invoke: function (module, name, param) {
                    module = module || '';
                    name = name || '';
                    param = param || '{}';
                    window.mkAobj.bridgejs(module, name, param);
                },
            };
        }
        return {
            name: 'android prompt',
            invoke: function (module, name, param) {
                window.prompt(_this.mkURL(module, name, param));
            },
        };
    },
};
if (!mm$2.is_mk) {
    console.warn('当前环境不是mk webview?');
}
prepare.initMK();
if (window) {
    window['mm'] = mm$2;
}

// 设备相关
var device = {
    bindPhone: function(param, callback){
        mm.build({
            common: ['device','bindPhone',{},callback],
        });
    },
    /* 计步器获取步数 */
    getStepCounter: function(callback){
        mm.build({
            common: ['device','getStepCounter',{},callback],
        });
    },
    /*
        唤起原生短信界面，发送短信
        */
    sendSMS: function(param){
        mm.build({
            common: ['device','sendSMS',param],
        });
    },
    callPhone: function(param){
        mm.build({
            common: ['device','callPhone',param],
        });
    },
    /*
        获取用户系统信息
        返回值：
        systemName: 'iOS',// 系统内核 IOS/Android
        systemVersion: '8.0', // 系统内核版本
        model: 'iPhone',    // 系统型号
        modelVersion: '6',  // 系统型号版本
        */
    getSystemInfo: function(callback){
        mm.build({
            common: ['device','getSystemInfo',{},callback],
        });
    },
    getClientInfo: function(callback){
        mm.build({
            common: ['device','getClientInfo',{},callback],
        });
    },
    getScreenInfo: function(callback){
        mm.build({
            common: ['device','getScreenInfo',{},callback],
        });
    },
    getBatteryInfo: function(callback){
        mm.build({
            common: ['device','getBatteryInfo',{},callback],
        });
    },
    getNetworkType: function(callback){
        mm.build({
            common: ['device','getNetworkType',{},callback],
        });
    },
    startNetWorkListening: function(param){
        mm.build({
            common: ['device','startNetWorkListening',param],
        });
    },

    getReferee: function(param, callback){
        mm.build({
            common: ['device','getReferee',{},callback],
        });
    }
};

var globalEvent = {
    // 增加监听事件
    addEventListener: function (param, callback) {
        if (!/^bn/.test(param.name) && !param.target) {
            param.target = '*';
        }
        mm.build({
            common: ['globalEvent', 'addEventListener', param, callback],
            version: {sdk: '1.0'},

        });
    },
    // 移除监听事件
    removeEventListener: function (param) {
        if (!/^bn/.test(param.name) && !param.target) {
            param.target = '*';
        }
        mm.build({
            common: ['globalEvent', 'removeEventListener', param],
            version: {sdk: '1.0'},
        });
    },
    // 向监听事件发送消息
    postEvent: function (param) {
        if (!/^bn/.test(param.name) && !param.target) {
            param.target = '*';
        }
        mm.build({
            common: ['globalEvent', 'postEvent', param],
            version: {sdk: '1.0'},
        });
    },
};

var http = {
    /**
     * 拉取json数据
     * @param {Object} param 请求参数
     *  - method: 客户端请求均为post
     *  - timeout: 超时时间，默认无超时时间
     * @param callback 回调
     * @doc http://local.m.immomo.com:8080/mk/#http-request
     */
    request: function (param, callback) {
        param.method = 'post';
        var is_encode;
        if (mm.compareMK('1.0') < 0) {
            if (mm.compare('7.0.9') >= 0 && mm.compare({
                ios: '7.4.1',
                android: '7.7',
            }) < 0) {
                is_encode = true;
                param.encode = 1;
            }
        }
        if (param.encode == 1) {
            is_encode = true;
        }
        var newCallback = function (info) {
            if (is_encode) {
                try {
                    var codeInfo = window.atob(info);
                    codeInfo = escape(codeInfo);  // atob鍚庯紝澶勭悊涓枃
                    codeInfo = decodeURIComponent(codeInfo);
                    info = JSON.parse(codeInfo);
                } catch (err) {
                }
            } else {
                if (typeof info == 'string' && mm.platform === 'android') {
                    try {
                        var codeInfo = decodeURIComponent(info);
                        info = JSON.parse(codeInfo);
                    } catch (err) {
                    }
                }
                if (typeof info == 'string') {
                    try {
                        var codeInfo = info.replace(/\\/g, '\\\\')
                            .replace(/\t/g, '\\t')
                            .replace(/\n/g, '\\n')
                            .replace(/\f/g, '\\f')
                            .replace(/\r/g, '\\r')
                            .replace(/[\x00-\x1F\x7F-\x9F]/g, '');
                        info = JSON.parse(codeInfo);
                    } catch (err) {

                    }
                }
            }

            callback && callback.call(null, info);
        };


        var handler = mm.build({
            common: ['http', 'request', param, function (info) {
                newCallback.call(null, info);
                handler.release();
            }],
        });
    },
    resetSession: function (callback) {
        mm.build({
            common: ['http', 'resetSession', {}, callback],
        });
    },
};

/**
 * @file 媒体bridge
 */

var media = {
    previewImage: function (param, callback) {
        mm.build({
            common: ['media', 'previewImage', param, callback],
            version: {sdk: '1.0', momo: '6.10'},
        });
    },

    readImages: function (param, callback) {
        mm.build({
            common: ['media', 'readImages', param, callback],
            version: {sdk: '1.0', momo: '6.3'},

        });
    },
    startAudio: function (param, callback) {
        mm.build({
            common: ['media', 'startAudio', param, callback],
            version: {sdk: '1.0', momo: '5.8'},
        });
    },
    startVideo: function (param) {
        mm.build({
            common: ['media', 'startVideo', param],
            version: {sdk: '1.0', momo: '6.0'},
        });
    },
    stopAudio: function (param) {
        mm.build({
            common: ['media', 'stopAudio', param],
            version: {sdk: '1.0', momo: '5.8'},
        });
    },
    getImageData: function (param, callback) {
        mm.build({
            common: ['media', 'getImageData', param, callback],
            version: {sdk: '1.0', momo: '6.5'},
        });
    },
    getImages: function (param, callback) {
        mm.build({
            common: ['media', 'getImages', param, callback],
        });
    },
    //截屏8.1新增,萌宠
    screenShot: function (param, callback) {
        mm.build({
            common: ['media', 'screenShot', param, callback],
            version: {sdk: '1.0', momo: '8.1'},

        });
    },
    uploadImages: function (param, callback) {
        mm.build({
            common: ['media', 'uploadImages', param, callback],
            version: {sdk: '1.0', momo: '8.1'},
        });
    },
    saveBase64File: function (param, callback) {
        mm.build({
            common: ['media', 'saveBase64File', param, callback],
            version: {sdk: '1.0', momo: '8.1'},
        });
    },
    saveImagesToAlbum: function (param, callback) {
        mm.build({
            common: ['media', 'saveImagesToAlbum', param, callback],
            version: {sdk: '1.0', momo: '8.1'},
        });
    },

    // 拍摄视频
    shotVideo: function (param, callback) {
        mm.build({
            common: ['media', 'shotVideo', param, callback],
            version: {sdk: '1.1', momo: '8.2.1'},
        });
    },

    // 本地文件上传
    uploadFile: function (param, callback) {
        mm.build({
            common: ['media', 'uploadFile', param, callback],
            version: {sdk: '1.0', momo: '8.2.1'},
        });
    },
    uploadFiles: function (param, callback) {
        mm.build({
            common: ['media', 'uploadFiles', param, callback],
            version: {sdk: '1.0', momo: '8.21'},
        });
    },
    //调起客户端录音界面
    recordSound: function (param, callback) {
        mm.build({
            common: ['media', 'recordSound', param, callback],
            version: {sdk: '1.0', momo: '8.2.3'},

        });
    },
    //自定义录音
    customRecord: function (param, callback) {
        mm.build({
            common: ['media', 'customRecord', param, callback],
            version: {sdk: '1.0', momo: '8.2.4'},

        });
    },
};

/**
 * @file 离线包bridge
 */

var offline = {
    /**
     * @file 强制更新离线包，完成后回调
     * @param param
     *  bid
     *  url
     * @param callback
     *  status: 0,  // 更新离线包后的状态; 0 成功，1失败
     *  message: '' // 提示文字
     */
    //todo 未能成功验证
    update: function (param, callback) {
        mm.build({
            common: ['offline', 'update', param, callback],
            version: {sdk: '1.0', momo: '6.5'},
        });
    },

    /**
     * 强制批量更新离线包，完成后回调
     * @param param
     *  bid:[],
     *  url:[]
     * @param callback
     *  status: 0,  // 更新离线包后的状态; 0 成功，1失败
     *  list:[],    // 失败的离线包
     *  message: '' // 提示文字
     */
    //todo 未能成功验证
    batchUpdate: function (param, callback) {
        return mm.build({
            common: ['offline', 'batchUpdate', param, callback],
        });
    },

    checkUpdate: function (param, callback) {
        return mm.build({
            common: ['offline', 'checkUpdate', param, callback],
            version: {sdk: '1.0', momo: '6.5'},

        });
    },

    //todo 未能成功验证
    isCached: function (param, callback) {
        return mm.build({
            common: ['offline', 'isCached', param, callback],
        });
    },

    /**
     * 移除所有离线包
     * @param callback
     */
    clearCache: function (callback) {
        return mm.build({
            common: ['offline', 'clearCache', {}, callback],
            version: {sdk: '1.0', momo: '6.5'},

        });
    },

    /**
     * 移除某个离线包
     * @param param
     *  bid
     * @param callback
     */
    removeCache: function (param, callback) {
        return mm.build({
            common: ['offline', 'removeCache', param, callback],
            version: {sdk: '1.0', momo: '6.5'},

        });
    },

    /**
     * 获取zip包版本号
     * @param param
     * @param callback
     *  '10' // 0 if it's null
     */
    //todo 未能成功验证
    getVersion: function (param, callback) {
        return mm.build({
            common: ['offline', 'getVersion', param, callback],
            version: {sdk: '1.0', momo: '6.5'},

        });
    },

    //todo 未能成功验证
    isResourceOfflined: function (param, callback) {
        return mm.build({
            common: ['offline', 'isResourceOfflined', param, callback],
        });
    },

    //todo 未能成功验证
    sendOfflineRequest: function (param, callback) {
        return mm.build({
            common: ['offline', 'sendOfflineRequest', param, callback],
            version: {sdk: '1.0', momo: '8.1'},
        });
    },
};

/**
 * @file 本地存储
 */

var storage = {

    /**
     * 获取某条数据
     * @param param
     *  callid {string} 用来标示请求id, 返回时把该值传回
     *  host {string} 如果host不为空, 且是该页面的域名的父域名, 则往host写, 如果为空则往页面的域名写, 其他为错误
     *  path {string} 区分业务
     *  key {string} 数据对应的key
     * @param callback
     */
    getItem: function (param, callback) {
        if (!mm.is_webview) {
            var _val = localStorage.getItem(param.key);
            callback(_val);
            return;
        }

        mm.build({
            common: ['storage', 'getItem', param, callback],
            version: {sdk: '1.0', momo: '6.5'},

        });
    },
    setItem: function (param) {
        param.value += '';
        if (!mm.is_webview) {
            localStorage.setItem(param.key, param.value);
            return;
        }
        if (param.value.length > 100 * 1024 && mm.compareMK('1.0') >= 0) {
            throw 'setItem 字符超长';
        }

        if (param.value.length > 100 * 1024 && mm.compare(7.6) >= 0) {
            throw 'setItem 字符超长';
        }

        mm.build({
            common: ['storage', 'setItem', param],
            version: {sdk: '1.0', momo: '6.5'},
        });
    },
    removeItem: function (param) {
        if (!mm.is_webview) {
            localStorage.removeItem(param.path + param.key);
            return;
        }
        mm.build({
            common: ['storage', 'removeItem', param],
            version: {sdk: '1.0', momo: '6.5'},
        });
    },
    clearItem: function (param) {
        if (!mm.is_webview) {
            localStorage.clear();
            return;
        }
        //todo 双端check
        var name = 'clearItem';
        if (mm.platform === 'ios') {
            name = 'clear';
        }
        mm.build({
            common: ['storage', name, param],
            version: {sdk: '1.0', momo: '6.5'},

        });
    },
};

/**
 *  ui 相关bridge
 **/

var hasRefreshed = true;

var ui = {
    setBackBtn: function (callback) {
        mm.build({
            common: ['ui', 'setBackBtn', {}, callback],
            version: {sdk: '1.0', momo: '8.1'},

        });
    },
    openUrl: function(param){
        var url = param.url;
        if (!mm.is_webview) {
            setTimeout(function () {
                window.location.href = url;
            }, 20);
            return false;
        }

        if (param.pass) {
            param.url = 'https://passport.immomo.com/authorize?redirect_uri=' + encodeURIComponent(param.url);
        }
        mm.build({
            common: ['ui', 'openUrl', param]
        });
    },
    openGoto: function (param) {
        var endParam = param.param;
        mm.build({
            common: ['ui', mm.platform === 'ios' ? 'openGoto' : 'directGoto', mm.platform === 'ios'? {goto: endParam,}:{param: endParam,}],
        });
    },

    openLinkInExternalBrowser: function (param) {
        mm.build({
            common: ['ui', 'openLinkInExternalBrowser', param],
        });
    },
    goBack: function (param) {
        mm.build({
            common: ['ui', 'goBack', param],
        });
    },

    reload: function (param) {
        if (mm.is_webview) {
            mm.build({
                common: ['ui', 'reload', param],
            });
        } else {
            location.reload();
        }
    },
    close: function (param) {
        if (/momoPopup/.test(navigator.userAgent)) {
            mm.ui.closePopup(param);
            return;
        }
        mm.build({
            common: ['ui', 'close', param],
        });
    },
    closePopup: function (param) {
        mm.build({
            common: ['ui', 'closePopup', param],
        });
    },
    showNavBar: function () {
        mm.build({
            common: ['ui', 'showNavBar', {}],
        });
    },
    hideNavBar: function () {
        mm.build({
            common: ['ui', 'hideNavBar', {}],
        });
    },
    showKeyboard: function (param) {
        mm.build({
            common: ['ui', 'showKeyboard', param],
        });
    },
    showMessage: function (param) {
        mm.build({
            common: ['ui', 'showMessage', param],
        });
    },
    showConfirm: function (param) {
        var newCallback = function (resp) {
            if (!resp) return;
            switch (resp.button) {
                case 0:
                    param.cancel && param.cancel();
                    break;
                case 1:
                    param.callback1 && param.callback1();
                    break;
                case 2:
                    param.callback2 && param.callback2();
                    break;
                default:
                    break;
            }
            param.finish && param.finish(resp);
        };

        mm.build({
            common: ['ui', 'showConfirm', param, newCallback],
        });
    },
    setUI: function (param) {
        mm.build({
            common: ['ui', 'setUI', param],
        });
    },
    setTitle: function (param) {
        if (param && param.title) {
            document.title = param.title;
        }
        mm.build({
            common: ['ui', 'setTitle', param],
        });
    },
    setPulldown: function (param) {
        mm.build({
            common: ['ui', 'setPulldown', param],
        });
    },
    setUIBtn: function (param, callback) {
        mm.build({
            common: ['ui', 'setUIBtn', param, callback],
        });
    },
    setUIGroup: function (param) {
        var newCallback = function (resp) {
            if (resp && typeof resp.btn != 'undefined') {
                param.btns[resp.btn].callback(resp);
            }
        };
        mm.build({
            common: ['ui', 'setUIGroup', param, newCallback],
        });
    },
    //todo wiki里没有
    clearPageCover: function (callback) {
        if (mm.platform !== 'ios') return;
        mm.build({
            common: ['ui', 'clearPageCover', {}, callback],
        });
    },

    getVisibility: function (callback) {
        mm.build({
            common: ['ui', 'getVisibility', {}, callback],
        });
    },
    /* 下拉刷新 */
    refresh: function (callback) {
        hasRefreshed = true;
        var t;
        var reTime = function () {
            if (!hasRefreshed) {
                mm.ui.refreshEnd();
            }
        };
        var newCallback = function () {
            hasRefreshed = false;
            clearTimeout(t);
            t = setTimeout(reTime, 16000);

            setTimeout(function () {
                callback && callback.call(null);
            }, 0);
        };
        mm.build({
            common: ['ui', 'refresh', {}, newCallback],
        });
    },
    /* 下拉刷新结束 */
    refreshEnd: function () {
        hasRefreshed = true;
        mm.build({
            common: ['ui', 'refreshEnd', {}],
        });
    },
    /*禁止划动退出页面*/
    forbidLeftSlide: function (param) {
        mm.build({
            common: ['ui', 'forbidLeftSlide', param],
        });
    },
    /*展示礼物动效*/
    displayGift: function (param, callback) {
        mm.build({
            common: ['ui', 'displayGift', param, callback],
        });
    },
    /*多webview通信*/
    postMessage: function (param, callback) {
        mm.build({
            common: ['ui', 'postMessage', param, callback],
        });
    },
};

/**
 *  view 预渲染 bridge
 **/


var view = {
  prepare: function(param, callback) {
    mm.build({
      common: ['view', 'prepare', param, callback],
      version: {sdk: '1.0', momo: {ios: '8.2.4', android: '8.2.4'}},
    });
  },
  destroy: function(param, callback) {
    mm.build({
      common: ['view', 'destroy', param, callback],
      version: {sdk: '1.0', momo: {ios: '8.2.4', android: '8.2.4'}},
    });
  },

};

var _isSupport7_1 = mm.compare('7.0.9') > 0;
var _analy = {    // 发送统计ajax时间的对象
  firstTime: 0,
  lastTime: 0,
  sendCount: 0,
  count: 0,
  isLoaded: false,
  cache: false,
};
var _allAnaly = {
  start: {},
  data: {},
  net: 'none',
};

// 获取网络情况
var deviceBack = function(res) {
  _allAnaly.net = res.network_type;
};
mm.invoke('device', 'getNetworkType', {}, deviceBack);

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
}

// ajax begin
function addAjaxParam(key, value) {
  if (typeof value == 'function') value = value();
  if (value == null) value = '';
  return encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function getAjaxData(params, obj, scope, isNative) {
  var value, type,
    array = Array.isArray(obj) || obj instanceof Array,
    hash = Object.prototype.toString.call(obj) === '[object Object]' && Object.getPrototypeOf(obj) == Object.prototype;

  for (var key in obj) {
    value = obj[key];
    type = typeof value;

    // if (scope) key = scope + '[' + (hash || type == 'object' ? key : '') + ']'
    if (scope) key = scope + '[' + key + ']';
    // handle data in serializeArray() format
    if (!scope && array) {
      if (isNative) {
        params[key] = value;
      } else {
        params.push(addAjaxParam(key, value));
      }
    }
    // recurse into nested objects
    else if (type == 'object') {
      getAjaxData(params, value, key, isNative);
    } else {
      if (isNative) {
        params[key] = value;
      } else {
        params.push(addAjaxParam(key, value));
      }

    }
  }
}

function localAjax(ajaxOpt) {
  var xhr = new window.XMLHttpRequest(),
    data = ajaxOpt.data || '',
    url = ajaxOpt.url,
    ajaxError = ajaxOpt.error,
    ajaxSuccess = ajaxOpt.success;

  xhr.onreadystatechange = function() {
    if (xhr.readyState == 4) {
      var result,
        error = false;
      if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304 || (xhr.status == 0 && location.protocol == 'file:')) {
        result = xhr.responseText;

        try {
          // http://perfectionkills.com/global-eval-what-are-the-options/
          result = /^\s*$/.test(result) ? null : JSON.parse(result);
        } catch (e) {
          error = e;
        }

        if (error) {
          ajaxError(error, 'parsererror', xhr);
        } else {
          ajaxSuccess(result, xhr);
        }
      } else {
        ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr);
      }
    }
  };
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.withCredentials = true; // 携带跨域cookie

  if (data && typeof data != 'string') {
    var params = [];
    getAjaxData(params, data);

    data = params.join('&').replace(/%20/g, '+');
  }

  xhr.send(data);
}

// ajax end

window.addEventListener('load', function() {
  _analy.isLoaded = true;
  CommonSendAjaxMMA(true);
}, false);

function CommonSendAjaxMMA(isLoadEvent, options) {
  if (!_analy) return;
  if (!isLoadEvent && options.analy) {
    _analy.count++;
    _analy.lastTime = Date.now();
  }

  if (_analy.isLoaded && _analy.sendCount <= _analy.count) {
    if (_analy.firstTime) {
      if (typeof MMA != 'undefined') {
        delete _analy.sendCount;
        delete _analy.isLoaded;
        MMA.addInit({
          ajax: _analy,
        });
        if (MMA.sendLog) {
          MMA.sendLog(_allAnaly.data);
        }
        _analy = null;
        _allAnaly.data = null;
      }
    } else {
      _analy = null;
    }
  }
}

function sendMMA(url, ext, cxp) {
  if (typeof MMA == 'undefined') return;

  MMA.sendEvent(null, {
    api: 1,
    lucky: 1,
    et: 4,
    cu: url,
    cxp: cxp || 'ajax_error',
    ext: ext,
  });
}

function getRequest(options, storageObj) {
  this.options = options;
  this.storageObj = storageObj;
  this.resp = null;

  if (_analy) {
    if (!_analy.firstTime) _analy.firstTime = Date.now();
    if (options.analy) {
      _analy.sendCount++;
    }
  }
  _allAnaly.start[options.url + storageObj.cacheKey] = Date.now();

  /*
      如果在陌陌客户端，执行mm.http.request
      如果不在陌陌客户端，执行ajax
      */
  if (options.useCache) {
    /*
        如果用缓存，获取localstorage中的值
        并执行ajax，与localstorage的值进行比较，如果不同，重复success操作
        如果不用缓存，每次进行请求
        */
    this.getLocalStorage.apply(this, arguments);
  } else {
    this.sendRequest.apply(this, arguments);
  }
}

var getSession = (function() {
  var isSet = false,
    sessionStatus = null,
    requestArr = [],
    errorArr = [],
    isLowAndroid = mm.platform == 'android' && mm.build_version < 1650; // android < 8.5版本，不支持立即获取到登陆信息

  return function(resp, options) {
    var canReload = !isLowAndroid && options.autoReload;
    if (sessionStatus == 0) {
      // 如果已经获取过登陆信息，第一次请求返回xxx401，执行重复发送请求
      //                     第二次请求返回xxx401，返回失败 - false
      if (requestArr.indexOf(this) == -1 && canReload) {
        this.sendRequest();
        return true;
      }
      return false;
    } else if (sessionStatus == 1) {
      // 如果获取登陆信息失败，返回失败
      return false;
    }

    // 获取登陆信息
    requestArr.push(this);
    errorArr.push(resp);
    if (!isSet) {
      isSet = true;
      mm.invoke('http', 'resetSession', {}, function(sess) {
        // 高版本安卓、ios，获取登陆信息成功后，重新发送请求
        if (canReload && sess.status == 0) {
          sessionStatus = 0;
          for (var i = 0; i < requestArr.length; i++) {
            requestArr[i].sendRequest();
          }
        }

        // 低版本安卓，或获取登陆信息失败，执行callback
        if (!canReload || sess.status != 0) {
          sessionStatus = 1;
          for (var i = 0; i < requestArr.length; i++) {
            requestArr[i].onlineSuc(errorArr[i]);
          }
        }
      });
    }
    return true;
  };
})();

getRequest.prototype = {
  getLocalStorage: function() {
    var _self = this;
    var options = this.options;
    var storageObj = this.storageObj;
    _self.sendRequest(arguments);

    var resp = localStorage.getItem(storageObj.path + storageObj.key);
    if (!resp) return;

    var dt;
    if (_isSupport7_1) {
      try {
        var dt = window.atob(resp);
        dt = escape(dt); // atob后，处理中文
        dt = decodeURIComponent(dt);
        options._mock.origin = dt;
        dt = JSON.parse(dt);
      } catch (err) {
        dt = _self.changeCode(resp);
      }
    } else {
      dt = _self.changeCode(resp);
    }

    options._mock.originObj = dt;
    options.success.call(options, dt);
    if (_analy) {
      _analy.cache = true;
    }
  },
  changeCode: function(resp) {
    var dt;
    try {
      dt = JSON.parse(resp);
    } catch (err) {
      try {
        var codeInfo = resp.replace(/\\/g, '\\\\').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\f/g, '\\f').replace(/\r/g, '\\r').replace(/[\x00-\x1F\x7F-\x9F]/g, '');
        dt = JSON.parse(codeInfo);
      } catch (err) {
        dt = resp;
      }
    }

    this.options._mock.origin = resp;
    return dt;
  },
  sendRequest: function() {
    var _self = this;
    var options = this.options;
    var sendObj = {
      url: options.url, // 请求的url
      data: options.data,
      dataType: 'json',
      type: 'POST', // 强制使用post
      encode: options.encode,
      header: options.header
    };
    // data参数数据类型
    if (options.requestType){
      sendObj.requestType = options.requestType;
    }
    // 如果是mk webview 使用bridge请求，否则用ajax请求
    if (mm.is_webview) {
      // 兼容android < 8.5 不支持data嵌套数组
      if (mm.platform == 'android') {
        var params = {};
        getAjaxData(params, sendObj.data, null, true);
        sendObj.data = params;
      }
      mm.http.request(sendObj, function(resp) {
        if (resp) {
          if (typeof resp == 'object') {
            if (resp.ec && (resp.ec < 0 || resp.ec == 1)) {
              resp.em = '网络好像有点问题';
              options.success && options.success.call(options, resp);
              // 如果从cache获取到数据，执行finish
              if (options._mock.originObj && options.finish) {
                options.finish.call(options, options._mock.originObj);
              }
              sendMMA(options.url, resp);
              return;
            }
            if (/^\d\d\d401$/.test(resp.ec) && getSession.call(_self, resp, options)) {
              // 如果 getSession == true，即可以获取到session，则暂停后续操作
              // 如果 getSession == false，即没有session 或 没有session回调，则继续执行后续操作
              return;
            }
          } else {
            sendMMA(options.url, resp, 'ajax_datatype');
          }
        }

        _self.onlineSuc(resp);
      });
    } else {
      try {
        sendObj.success = function(resp) {
          _self.onlineSuc.call(_self, resp);
        };
        sendObj.error = function(resp, textState) {
          if (resp) {
            _self.onlineErr({
              ready: resp.readyState,
              status: resp.status,
              text: textState,
            }, resp);
          }

          return;
        };
        localAjax(sendObj);
      } catch (err) {
        console.warn('mock warn: $.ajax error');
      }
    }
  },
  onlineSuc: function(resp) {
    var _self = this;
    var options = this.options;
    var storageObj = this.storageObj;
    if (options.useCache && !!resp) {
      var is_obj = typeof resp == 'object';
      var dataStr = is_obj ? JSON.stringify(resp) : resp;

      if (_isSupport7_1) {
        var dataStr = encodeURIComponent(dataStr);
        dataStr = unescape(dataStr);
        dataStr = window.btoa(dataStr);
      }

      if (!!options._mock.origin && options._mock.origin == dataStr && options.finish) {
        options.finish.call(options, resp);
        return false;
      }

      if (!is_obj || is_obj && (resp.ec == 200 || resp.ec == 0)) {

        extend(storageObj, {
          value: dataStr,
        });
        localStorage.setItem(storageObj.path + storageObj.key, dataStr);
      }
    }
    options.end = true;
    // 添加请求时间统计
    var now = Date.now();
    var send = {};
    send[now] = {
      type: 'ajax',
      data: {
        net: _allAnaly.net,
        uri: options.url.replace(/\?.*/, ''),
        wt: now - _allAnaly.start[options.url + storageObj.cacheKey],
        origin: location.href.replace(/\?.*/, ''),
        bid: mm.query._bid ? mm.query._bid[0] : '',
      },
    };
    if (_allAnaly.data) {
      _allAnaly.data[now] = send[now];
    } else {
      if (MMA.sendLog) {
        MMA.sendLog(send);
      }
    }

    if (options._mock.origin) {
      options.update.call(options, resp);
    } else {
      options.success.call(options, resp);
    }
    if (options.finish) {
      options.finish.call(options, resp);
    }
  },
  onlineErr: function(err, resp) {
    var options = this.options;
    if (options.error) options.error.call(options, resp);
    sendMMA(options.url, err);
  },
};

var mock = {
  ajax: function(opt) {
    var options = extend({}, opt);
    var _success = options.success,
      _update = options.update,
      _error = options.error,
      _finish = options.finish,
      _progress = options.progress,
      cacheKey = options.cacheKey;
    options.encode = opt.encode || 0;
    options._mock = {};
    // 初始化设置是否自动设置session并重新发送请求
    if (typeof options.autoReload == 'undefined') {
      options.autoReload = true;
    }

    /*
        mk.immomo.com：
        pc 和 非mk：'https://m.immomo.com/mk' + url
        mk：'https://mk.immomo.com' + url
    */

    if (opt.host) {
      if (mm.is_webview) {
        options.url = opt.host + options.url;
      } else {
        if (opt.host.indexOf('mk.immomo.com') > -1) {
          if (mm.is_webview) {
            mk.showError(); // 非mk webview不支持加密域名
            sendMMA(opt.host + options.url, '', 'mk_url_error');
            return;
          }
          options.url = '/mk' + options.url;
        } else {
          // pc非mk.immomo.com的，统一添加host
          options.url = opt.host + options.url;
        }
      }
    } else {
      if (mm.is_webview && !/^http/.test(options.url)) {
        options.url = mm.protocol + '//' + mm.host + options.url;
      }
    }

    if (!cacheKey) {
      var opt_data = options.url;
      if (options.data) {
        opt_data += options.url.indexOf('?') > -1 ? '&' : '?';
        var data_arr = [];
        for (var k in options.data) {
          data_arr.push(k + '=' + options.data[k]);
        }
        opt_data += data_arr.join('&');
      }
      cacheKey = encodeURI(opt_data);
    }
    var storageObj = {
      path: options.cachePath || '',
      key: cacheKey,
    };

    // 线上数据返回 callback
    options.success = function(data, status, xhr) {
      CommonSendAjaxMMA(false, options);
      _success && _success.apply(options, arguments);
      _progress && _progress.apply(options, arguments);
    };

    // 数据更新时 callback
    options.update = function(data, status, xhr) {
      _update && _update.apply(options, arguments);
      _progress && _progress.apply(options, arguments);
    };

    options.error = function(xhr, errorType, error) {
      CommonSendAjaxMMA(false, options);
      _error && _error.apply(options, arguments);
    };

    new getRequest(options, storageObj);
  },
  /*
      错误提示，可以通过修改 mk.showError 来改变
      */
  showError: function(errorText) {
    errorText = errorText || '网络好像有点问题';
    if (typeof mm != 'undefined') {
      mm.invoke('ui', 'showMessage', {
        status: 2,
        message: errorText,
      });
    }
  },
  post: function(url, data, success) {
    if (typeof data == 'function') success = data, data = undefined;

    return mk.ajax({
      url: url,
      data: data,
      success: success,
    });
  },
};

if(window.mm){
  mm.ajax=mock.ajax;
}

mm$2.device = device;
mm$2.globalEvent = globalEvent;
mm$2.http = http;
mm$2.media = media;
mm$2.offline = offline;
mm$2.storage = storage;
mm$2.ui = ui;
mm$2.view = view;
 
mm$2.ajax = mock.ajax;
mm$2.post = mock.post;
mm$2.post = mock.showError;

mm$2.init = function () {
    mm$2.ui.setUIBtn();
};

export default mm$2;
